// EditorialByTheNumbers, number-led storytelling band.
//
// Large serif numerals carry the structural facts about Zuriya at this
// stage of life: 7 crafts, 84 city pages, 0% commission on repeat
// bookings, 1 community. Set against the dark charcoal so it lands as
// a cinematic full-bleed beat between the contents list and the rate
// card. Mono captions sit underneath each numeral like museum labels.
const STATS = [
  {
    figure: '07',
    label: 'Crafts on the platform',
    note: 'From locs to lashes, mapped to how stylists actually work.',
  },
  {
    figure: '84',
    label: 'City landing pages live',
    note: 'Every UK region we serve, indexed for search and the curious.',
  },
  {
    figure: '0%',
    label: 'Commission on repeat clients',
    note: 'Your regulars never become someone else\u2019s margin.',
  },
  {
    figure: '01',
    label: 'Community, finally with a home',
    note: 'Built by us, with us, for the way we already book beauty.',
  },
];

export function EditorialByTheNumbers() {
  return (
    <section
      className="relative bg-[#1A1A1A] text-white py-20 lg:py-28 overflow-hidden"
      data-testid="editorial-numbers"
    >
      {/* Faint editorial gridlines for atmosphere */}
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none opacity-[0.04]"
      >
        <div className="h-full w-full bg-[linear-gradient(to_right,_white_1px,_transparent_1px),_linear-gradient(to_bottom,_white_1px,_transparent_1px)] bg-[size:120px_120px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl mb-14 lg:mb-20">
          <span className="font-mono text-xs tracking-[0.3em] uppercase text-[#D4AF37]">
            By the numbers
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight font-medium text-white mt-3 leading-[1.05]">
            Small platform. <span className="italic text-stone-400">Big intent.</span>
          </h2>
        </div>

        {/* Numerals row, divided by hairline rules so it reads as a single
            spread rather than four floating cards. */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-12 lg:gap-y-0 lg:divide-x divide-white/15">
          {STATS.map((s, i) => (
            <div
              key={s.figure}
              className={`lg:px-8 ${i === 0 ? 'lg:pl-0' : ''} ${i === STATS.length - 1 ? 'lg:pr-0' : ''}`}
              data-testid={`stat-${i + 1}`}
            >
              <p className="font-heading text-7xl lg:text-8xl text-[#D4AF37] leading-none tracking-tight">
                {s.figure}
              </p>
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/60 mt-4">
                {s.label}
              </p>
              <p className="text-sm text-white/70 mt-3 leading-relaxed max-w-[26ch]">
                {s.note}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
